module.exports = __webpack_public_path__ + "static/media/o5.17721843.svg";